/* eslint-disable */
// JS imports
import Control from 'ol/control/Control';

export default class Sidebarx extends Control {

    constructor(opt_options) {

        var defaults = {
            element: null,
            position: 'left'
        }, i, child;

        var options = Object.assign({}, defaults, opt_options);

        var element = document.getElementById(options.element);

        super({
            element: element,
            target: options.target
        });

        // Attach .sidebarx-left/right class
        element.classList.add('sidebarx-' + options.position);

        // Find sidebarx > div.sidebarx-content
        for (i = element.children.length - 1; i >= 0; i--) {
            child = element.children[i];
            if (child.tagName === 'DIV' &&
                    child.classList.contains('sidebarx-content')) {
                this._container = child;
            }
        }

        // Find sidebarx ul.sidebarx-tabs > li, sidebarx .sidebarx-tabs > ul > li
        this._tabitems = element.querySelectorAll('ul.sidebarx-tabs > li, .sidebarx-tabs > ul > li');
        for (i = this._tabitems.length - 1; i >= 0; i--) {
            this._tabitems[i]._sidebarx = this;
        }

        // Find sidebarx > div.sidebarx-content > div.sidebarx-pane
        this._panes = [];
        this._closeButtons = [];
        for (i = this._container.children.length - 1; i >= 0; i--) {
            child = this._container.children[i];
            if (child.tagName == 'DIV' &&
                    child.classList.contains('sidebarx-pane')) {
                this._panes.push(child);

                var closeButtons = child.querySelectorAll('.sidebarx-close');
                for (var j = 0, len = closeButtons.length; j < len; j++) {
                    this._closeButtons.push(closeButtons[j]);
                }
            }
        }
    }

    /**
    * Set the map instance the control is associated with.
    * @param {ol.Map} map The map instance.
    */
    setMap(map) {
        var i, child;

        for (i = this._tabitems.length - 1; i >= 0; i--) {
            child = this._tabitems[i];
            var sub = child.querySelector('a');
            if (sub.hasAttribute('href') && sub.getAttribute('href').slice(0,1) == '#') {
                sub.onclick = this._onClick.bind(child);
            }
        }

        for (i = this._closeButtons.length - 1; i >= 0; i--) {
            child = this._closeButtons[i];
            child.onclick = this._onCloseClick.bind(this);
        }
    };

    open(id) {
        var i, child;

        // hide old active contents and show new content
        for (i = this._panes.length - 1; i >= 0; i--) {
            child = this._panes[i];
            if (child.id == id)
                child.classList.add('active');
            else if (child.classList.contains('active'))
                child.classList.remove('active');
        }

        // remove old active highlights and set new highlight
        for (i = this._tabitems.length - 1; i >= 0; i--) {
            child = this._tabitems[i];
            if (child.querySelector('a').hash == '#' + id)
                child.classList.add('active');
            else if (child.classList.contains('active'))
                child.classList.remove('active');
        }

        // open sidebarx (if necessary)
        if (this.element.classList.contains('collapsed')) {
            this.element.classList.remove('collapsed');
        }

        return this;
    };

    close() {
        // remove old active highlights
        for (var i = this._tabitems.length - 1; i >= 0; i--) {
            var child = this._tabitems[i];
            if (child.classList.contains('active'))
                child.classList.remove('active');
        }

        // close sidebarx
        if (!this.element.classList.contains('collapsed')) {
            this.element.classList.add('collapsed');
        }

        return this;
    };

    _onClick(evt) {
        evt.preventDefault();
        if (this.classList.contains('active')) {
            this._sidebarx.close();
        } else if (!this.classList.contains('disabled')) {
            this._sidebarx.open(this.querySelector('a').hash.slice(1));
        }
    };

    _onCloseClick() {
        this.close();
    };
}

// Expose Sidebarx as ol.control.Sidebarx if using a full build of
// OpenLayers
if (window.ol && window.ol.control) {
    window.ol.control.Sidebarx = Sidebarx;
}
/* eslint-enable */
